<template>
<div id="recordDownload" >
  <el-dialog :title="title" v-if="showDialog"  width="45rem" :append-to-body="true" :close-on-click-modal="false" :visible.sync="showDialog" :destroy-on-close="true" @close="close()" center>
    <el-row>
      <el-col :span="18" style="padding-top: 7px;">
        <el-progress :percentage="percentage"></el-progress>
      </el-col>
      <el-col :span="6" >
<!--       <el-dropdown size="mini" title="播放倍速" style="margin-left: 1px;" @command="gbScale">-->
<!--         <el-button-group>-->
<!--           <el-button size="mini" style="width: 100%">-->
<!--             {{scale}}倍速 <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
<!--           </el-button>-->
<!--         </el-button-group>-->
<!--        <el-dropdown-menu  slot="dropdown">-->
<!--          <el-dropdown-item command="1">1倍速</el-dropdown-item>-->
<!--          <el-dropdown-item command="2">2倍速</el-dropdown-item>-->
<!--          <el-dropdown-item command="4">4倍速</el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
        <el-button icon="el-icon-download" size="mini" title="点击下载可将以缓存部分下载到本地" @click="download()" >
          {{buttonText}}
        </el-button>
      </el-col>
    </el-row>
  </el-dialog>
</div>
</template>


<script>

import moment from "moment";

export default {
    name: 'recordDownload',
    created() {
    },
    data() {
        return {
          title: "下载中...",
          deviceId: "",
          channelId: "",
          buttonText: "停止缓存",
          downloadSession: "",
          downloadUrl: "",
          showDialog: false,
          scale: 1,
          percentage: 0.00,
          taskId: null,
          getProgressRun: false,
          getProgressForFileRun: false,
        };
    },
    methods: {
        openDialog: function (deviceId, channelId, downloadSession) {
            this.deviceId = deviceId;
            this.channelId = channelId;
            this.downloadSession = downloadSession;
            this.showDialog = true;
            this.getProgressRun = true;
            this.percentage = 0.0;
            this.getProgressTimer()
        },
        getProgressTimer(){
          if (!this.getProgressRun) {
            return;
          }
          if (this.percentage == 100 ) {
            this.getFileDownload();
            return;
          }
          setTimeout( ()=>{
            if (!this.showDialog) return;
            this.getProgress(this.getProgressTimer())
          }, 5000)
        },
        getProgress: function (callback){
            let that = this;
            this.$axios({
                method: "get",
                url:
                    "/api/record/download/percent/" +
                    that.deviceId +
                    "/" +
                    "?session_id=" +
                    that.downloadSession,
                params: {
                  token: this.$cookies.get("session").token,
                }
            })
                .then(function (res) {
                    var info = res.data.data;
                    that.percentage = info.percent;
                    if (that.percentage >= 100) {
                        that.percentage = 100;
                        that.downloadUrl = info.url;
                        that.changeButtonText();
                    }
                    if (callback)callback();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        close: function (){
          if (this.percentage < 100) {
            this.stopDownloadRecord();
          }
          this.showDialog=false;
          this.getProgressRun = false;
          this.getProgressForFileRun = false;
        },
        gbScale: function (scale){
          this.scale = scale;
        },
        download: function (){
          let that = this;
          if (that.percentage < 100) {
            that.stopDownloadRecord(function (res) {
                console.log('stop ' + JSON.stringify(res.data));
                that.getProgress();
                // if (res.data.code == 0) {
                //   that.getProgressRun = false;
                // }
            });
          }
          else {
            that.getProgressRun = false;
            window.open(that.downloadUrl);
          }
        },
        stopDownloadRecord: function (callback) {
          let that = this;
          that.$axios({
            method: 'post',
            url: '/api/record/download/stop/' + that.deviceId + "?session_id=" + that.downloadSession,
            params: {
              token: that.$cookies.get("session").token,
            }
          }).then((res)=> {
            if (callback) callback(res)
          });
        },
        getFileDownload: function (){
          this.getProgress();
        },
        changeButtonText: function() {
          let that = this;
          if (that.percentage < 100) {
            that.buttonText = "停止缓存";
          }
          else {
            that.buttonText = "下载";
          }
        }
    }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialog/recordDownload.vue